export enum BannerDismissFor {
    Session = "Session",
    OneDay = "OneDay",
    ThreeDays = "ThreeDays",
    OneWeek = "OneWeek",
    OneMonth = "OneMonth",
    Once = "Once",
}